import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import {
    Button,
} from 'react-bootstrap';
// Redux form
import { Field, reduxForm } from 'redux-form';
import { compose } from 'redux';

import submit from './submit';
import messages from '../../locale/jsonMessages';

import Loader from '../Loader/Loader';

import { withQuery } from '../../hoc/withGraphql';
import { getAllUserReportType } from '../../lib/graphql/admin/manageReportType';
import { getDynamicReportContent } from '../../helpers/GetDynamicItemName/dynamicReportTypeHelper';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import cs from '../../components/commonStyle.css';
import s from './ReportUserForm.css';

const ReportUserForm = (props) => {

    const { error, handleSubmit, submitting, dispatch, reporterId, siteName, getUserReportTypes: { getAllUserReportType, loading } } = props;
    const { formatMessage } = useIntl();
    const { locale } = useIntl();

    let reportTypeData = getAllUserReportType?.results && getAllUserReportType?.results.length > 0 && getAllUserReportType?.results;

    return (
        loading ? (
            <Loader type={"text"} show={loading} loaderClass={'textLoader'} />
        ) : (
            <form onSubmit={handleSubmit(submit)}>
                {error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
                <h2 className={s.titleText}>
                    <FormattedMessage {...messages.reportUserInfo} />
                </h2>
                <div className={'customRatioButton'}>
                    {reportTypeData.map((item, index) => {
                        let reportContent = item?.DynamicReportTypeData && item?.DynamicReportTypeData.length > 0 ?
                            getDynamicReportContent({ value: item?.reportContent, locale, data: item?.DynamicReportTypeData }) : item?.reportContent;
                        return (
                            <div
                                key={item?.id || index}
                                className={cx(cs.commonMediumText, s.displayGrid, cs.alignItemFlexStart, cs.spaceBottom3)}
                            >
                                <Field
                                    name="reportId"
                                    component="input"
                                    type="radio"
                                    value={String(item?.id)}
                                    className={s.radioBtnInputSection}
                                />
                                <label className={cx(cs.noMargin, cs.adminLabelTextNew)}>{reportContent}</label>
                            </div>
                        );
                    })}
                    <div className={cx('singleBtnFlexEnd', cs.spaceTop4)}>
                        <Button className={cs.btnPrimary} type="submit" disabled={submitting}>
                            {formatMessage(messages.submit)}
                        </Button>
                    </div>
                </div>
            </form>
        )
    );
}

const mapState = state => ({
    siteName: state.siteSettings.data.siteName,
});

const mapDispatch = {};

export default reduxForm({
    form: 'ReportUserForm',
    destroyOnUnmount: false,
})(compose(
    withStyles(cs, s),
    connect(mapState, mapDispatch),
    withQuery(getAllUserReportType, {
        name: 'getUserReportTypes',
        options: {
            ssr: false,
            fetchPolicy: 'network-only',
        },
    })
)(ReportUserForm));
